import ko from 'vuetify/lib/locale/ko'
import global_config from '@/../config.json'

// Usage -> {{$vuetify.lang.t('$vuetify.close')}} -> 닫기
export default {
  ...ko,
  __General: {
    submit: '제출'
  },
  __InitialLoading: {
    connecting: '연결 중...'
  },
  __ChatBubbleAi: {
    default_answer_by: global_config.default_answer_by_ko || 'AI가 생성한 답변',
    default_answer_desc: global_config.default_answer_desc_ko || 'AI가 생성한 답변',
    answer_by_mrc: 'MRC에 의한 답변',
    mrc_answer_desc: 'MRC(기계 독해)는 텍스트 문서를 스캔하고 텍스트에서 의미를 추출합니다',
    answer_by_chatGPT: 'ChatGPT에 의한 답변',
    chatgpt_answer_desc: 'ChatGPT는 OpenAI에서 개발한 AI 챗봇으로, 자연어 처리를 사용하여 인간과 같은 대화를 생성합니다.',
    prompt_bar_message: '이 콘텐츠가 도움이 되었습니까?',
    comment_dialog: {
      title: '평가 이유를 공유해 주시겠습니까?',
      yes: '예',
      no: '아니요',
      placeholder: '여기에 댓글을 작성하세요',
      remaining_character: '남은 문자 수: {0}/{1}',
      submit: '제출',
      closing: '댓글 감사합니다!'
    }
  },
  __InputBar: {
    placeholder: '여기에 입력하세요 (개인 정보를 입력하지 마세요!)',
    press_to_record: '길게 눌러 녹음',
    press_once_to_record: '한 번 눌러 녹음',
    recording_press_once_to_stop: '녹음 중...(한 번 눌러 정지)',
    recording: '녹음 중...',
    upload_file: '파일 업로드',
    upload_file_error: '파일 업로드에 실패했습니다. 다시 시도하세요.',
    upload_file_success: '파일이 성공적으로 업로드되었습니다',
    file_size_limit: '파일 크기는 10MB를 초과할 수 없습니다',
    file_type_not_supported: '지원되지 않는 파일 형식입니다'
  }
}
